import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NoticeModel } from 'app/models/notice.model';

@Component({
    selector: 'app-card-disclosures-dialog',
    templateUrl: './card-disclosures-dialog.component.html',
    styleUrls: ['./card-disclosures-dialog.component.scss'],
    standalone: false
})
export class CardDisclosuresDialogComponent {
  public empty_msg = "By clicking 'I Agree' below, you are authorizing payment against the selected payment method.";

  public notices: NoticeModel[] = [];

  constructor(
    public dialogRef: MatDialogRef<CardDisclosuresDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NoticeModel[]) {
    this.notices = data ?? [];
  }

  onAgree(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
